// 商行详情 — 小票打印:码单模板编辑
import React, { PureComponent } from 'react';
import qs from 'qs';
import QRCode from 'react-qr-code';
// src/components 尚未封装 Space、Switch、message 和 Spin，沿用 antd-v5。
import { Space, Switch, message, Spin } from 'antd-v5';
import { Input, Button } from '@/components';
import PageHeaderLayout from '../../../../component/page-header-layout/index';
import { getAuthorityUserInfo } from '../../../../utils/authority';
import {
  requestThermalPrinterMemoTemplateEdit,
  requestThermalPrinterMemoTemplateView,
} from '../../../../state/request/tag';
import ThermalPrinterFieldChip, {
  ThermalPrinterNumberInput,
  ThermalPrinterTableHeadEditor,
  ThermalPrinterTextStyleChip,
  ThermalPrinterToggleChip,
} from './ThermalPrinterFieldChip';
import {
  MEMO_END_FIELDS,
  MEMO_HEAD_FIELDS,
  MEMO_PRODUCT_FIELDS,
  MEMO_TOTAL_FIELDS,
  STALL_THERMAL_PRINTER_TAB_KEY,
  cloneTemplate,
  getFieldStyle,
  normalizeMemoTemplate,
  updateFieldList,
} from './thermalPrinterTemplateShared';
import '../detail.less';
import './thermalPrinterTemplate.less';

const MEMO_STYLE_DEFS = [
  { key: 'custom', label: '配货单' },
  { key: 'no_price', label: '码单 · 不显示单价和总价' },
  { key: 'only_unit_price', label: '码单 · 仅显示单价' },
  { key: 'only_total_price', label: '码单 · 仅显示总价' },
  { key: 'both_price', label: '码单 · 显示单价和总价' },
];
const MEMO_STYLE_TAB_DEFS = [
  { key: 'custom', label: '配货单' },
  { key: 'madan', label: '码单' },
];
const MEMO_TEXT_STYLE_KEYS = ['no_price', 'only_unit_price', 'only_total_price', 'both_price'];
const MEMO_DISTRIBUTION_FONT_LINKED_KEYS = [
  'productName',
  'packWeight',
  'saleNumberWeight',
  'unitPrice',
  'goodsAmount',
  'packStatus',
];

const MEMO_SAMPLE = {
  memoNo: '0215',
  stallName: '标准版商行',
  buyerName: '周玉婷0001',
  qrcodeUrl: '商行二维码示例',
  qrcodeHint: '请使用微信付款',
  buyerAddress: '武汉四季美批发市场A区301号',
  plateNumber: '粤A12345',
  orderRemark: '拿新鲜的菜拿新鲜的菜拿新鲜的菜',
  products: [
    {
      name: '空心菜',
      category: '',
      batch: '批次0001',
      spec: '1件*15斤',
      qty: '7件(110斤)',
      qty2: '7件(110斤)',
      price: '2元/斤',
      amount: '220元',
      productRemark: '挑新鲜的',
      basket: { type: '小筐', qty: '1个', unitPrice: '20元', amount: '20元' },
    },
    {
      name: '龙眼',
      category: '水果类',
      batch: '',
      spec: '1箱*15斤',
      qty: '2箱(30斤)',
      qty2: '2箱(30斤)',
      price: '5元/斤',
      amount: '150元',
    },
  ],
};

const MEMO_FOOTER_SAMPLE = {
  createName: '张三',
  createTime: '2026-05-21 20:16',
  deliveryDate: '2026-05-22',
  marketName: '商行分类测试市场',
  stallTelephone: '15877774444',
  advertising: '诚信档口，就用菜小秘',
};

class StallThermalPrinterMemoEdit extends PureComponent {
  constructor(props) {
    super(props);
    const template = props.location.state?.template;
    this.state = {
      loading: !template,
      saving: false,
      template: normalizeMemoTemplate(template || {}),
      activeEditStyle: 'custom',
      previewStyleIndex: 0,
    };
  }

  componentDidMount() {
    this.scrollPageToTop();
    const { stallId } = this.props.location.state || {};
    if (!stallId) {
      message.warning('缺少商行信息');
      this.props.history.replace('/booth/stallManager');
      return;
    }
    if (!this.props.location.state?.template) {
      this.fetchTemplate(stallId);
    }
  }

  scrollPageToTop = () => {
    window.scrollTo(0, 0);
    const layoutContent = document.querySelector('.ant-layout-content');
    if (layoutContent) layoutContent.scrollTop = 0;
  };

  fetchTemplate = async (stallId) => {
    this.setState({ loading: true });
    try {
      const res = await requestThermalPrinterMemoTemplateView({ stallId });
      if (res?.code === 200) {
        this.setState({ template: normalizeMemoTemplate(res.data || {}) });
      }
    } catch {
    } finally {
      this.setState({ loading: false });
    }
  };

  goBackToStallDetail = () => {
    const { history, location } = this.props;
    const { stallId, tab = STALL_THERMAL_PRINTER_TAB_KEY } = location.state || {};
    if (!stallId) {
      history.push('/booth/stallManager');
      return;
    }
    history.push({
      pathname: '/booth/stallManager/stallManagementDetail',
      state: { stallId },
      search: qs.stringify({ tab: String(tab) }, { addQueryPrefix: true }),
    });
  };

  setTemplate = (updater) => {
    this.setState((prev) => {
      const draft = cloneTemplate(prev.template);
      return { template: updater(draft) || draft };
    });
  };

  setMemoStyle = (styleKey) => {
    if (styleKey === 'custom') {
      this.setState({
        activeEditStyle: 'custom',
        previewStyleIndex: 0,
      });
      return;
    }
    this.setState((prev) => {
      const currentIndex = MEMO_TEXT_STYLE_KEYS.includes(prev.activeEditStyle)
        ? MEMO_STYLE_DEFS.findIndex((item) => item.key === prev.activeEditStyle)
        : 1;
      const nextIndex = currentIndex >= 1 ? currentIndex : 1;
      return {
        activeEditStyle: MEMO_STYLE_DEFS[nextIndex].key,
        previewStyleIndex: nextIndex,
      };
    });
  };

  switchMemoPreviewStyle = (delta) => {
    this.setState((prev) => {
      const nextIndex =
        (prev.previewStyleIndex + delta + MEMO_STYLE_DEFS.length) % MEMO_STYLE_DEFS.length;
      return {
        previewStyleIndex: nextIndex,
        activeEditStyle: MEMO_STYLE_DEFS[nextIndex].key,
      };
    });
  };

  updateTopField = (key, next) => {
    this.setTemplate((draft) => {
      draft.headList = updateFieldList(draft.headList, key, next, MEMO_HEAD_FIELDS);
    });
  };

  updateFooterField = (key, next) => {
    this.setTemplate((draft) => {
      draft.endList = updateFieldList(draft.endList, key, next, MEMO_END_FIELDS);
    });
  };

  updateProductField = (key, next) => {
    this.setTemplate((draft) => {
      const productList = draft.tableTemplate.productList;
      const currentField = productList.find((item) => item.fieldName === key);
      const nextProductList = updateFieldList(productList, key, next, MEMO_PRODUCT_FIELDS);
      const shouldSyncFontSize =
        MEMO_DISTRIBUTION_FONT_LINKED_KEYS.includes(key) &&
        currentField &&
        currentField.fontSize !== next.fontSize;
      const shouldSyncBoldFlag =
        MEMO_DISTRIBUTION_FONT_LINKED_KEYS.includes(key) &&
        currentField &&
        currentField.boldFlag !== next.boldFlag;

      draft.tableTemplate.productList =
        shouldSyncFontSize || shouldSyncBoldFlag
          ? nextProductList.map((item) =>
              MEMO_DISTRIBUTION_FONT_LINKED_KEYS.includes(item.fieldName)
                ? {
                    ...item,
                    ...(shouldSyncFontSize ? { fontSize: next.fontSize } : {}),
                    ...(shouldSyncBoldFlag ? { boldFlag: next.boldFlag } : {}),
                  }
                : item,
            )
          : nextProductList;
    });
  };

  updateTotalField = (key, next) => {
    this.setTemplate((draft) => {
      draft.tableTemplate.totalList = updateFieldList(
        draft.tableTemplate.totalList,
        key,
        next,
        MEMO_TOTAL_FIELDS,
      );
    });
  };

  handleSave = async () => {
    const { stallId } = this.props.location.state || {};
    const { template, saving } = this.state;
    if (!stallId || saving) return;
    if ((template.qrcodeHint || '').length > 20) {
      message.error('二维码提示语最多20个字符');
      return;
    }
    if ((template.qrcodeUrl || '').length > 500) {
      message.error('二维码链接最多500个字符');
      return;
    }

    this.setState({ saving: true });
    try {
      const res = await requestThermalPrinterMemoTemplateEdit({
        stallId,
        templateBO: template,
      });
      if (res?.code === 200) {
        message.success('保存成功');
        this.goBackToStallDetail();
      } else if (res?.msg) {
        message.error(res.msg);
      }
    } catch {
    } finally {
      this.setState({ saving: false });
    }
  };

  renderFieldGrid = (metas, list, onFieldChange) => (
    <div className='thermalFieldGrid'>
      {metas.map((meta) => (
        <ThermalPrinterFieldChip
          key={meta.key}
          meta={meta}
          value={list.find((item) => item.fieldName === meta.key)}
          onChange={(next) => onFieldChange(meta.key, next)}
        />
      ))}
    </div>
  );

  renderStyleTabs = () => {
    const { activeEditStyle } = this.state;
    const activeTab = activeEditStyle === 'custom' ? 'custom' : 'madan';
    return (
      <React.Fragment>
        <div className='thermalStyleTabs'>
          {MEMO_STYLE_TAB_DEFS.map((item) => (
            <div
              key={item.key}
              className={`thermalStyleTab ${activeTab === item.key ? 'active' : ''}`}
              onClick={() => this.setMemoStyle(item.key)}
            >
              {item.label}
            </div>
          ))}
        </div>
        {activeTab === 'madan' ? (
          <div className='thermalStyleHint'>
            码单包含4种样式:不显示单价和总价、仅显示单价、仅显示总价、显示单价和总价
          </div>
        ) : null}
      </React.Fragment>
    );
  };

  renderPreview = () => {
    const { template, previewStyleIndex } = this.state;
    const headerFields = template.headList.filter((item) => item.printFlag);
    const productFields = template.tableTemplate.productList.filter((item) => item.printFlag);
    const productColumnFields = productFields.filter(
      (item) => !['productRemark', 'basketDesc'].includes(item.fieldName),
    );
    const productRemarkField = productFields.find((item) => item.fieldName === 'productRemark');
    const productBasketField = productFields.find((item) => item.fieldName === 'basketDesc');
    const totalFields = template.tableTemplate.totalList.filter((item) => item.printFlag);
    const footerFields = template.endList.filter(
      (item) => item.printFlag && item.fieldName !== 'advertising',
    );
    const advertisingField = template.endList.find(
      (item) => item.printFlag && item.fieldName === 'advertising',
    );
    const qrcodeUrl = template.autoSyncStallQrcodeUrl
      ? MEMO_SAMPLE.qrcodeUrl
      : (template.qrcodeUrl || '').trim();
    const qrcodeHint = template.autoSyncStallQrcodeUrl
      ? MEMO_SAMPLE.qrcodeHint
      : template.qrcodeHint;
    const underlineStyle = template.globalUnderline ? { borderBottom: '1px dashed #000' } : null;
    const styleDef = MEMO_STYLE_DEFS[previewStyleIndex] || MEMO_STYLE_DEFS[0];
    const previewStyle = styleDef.key;
    const showUnitPrice = previewStyle === 'only_unit_price' || previewStyle === 'both_price';
    const showGoodsAmount =
      previewStyle === 'both_price' && !!template.textTemplate.goodsAmountFlag;
    const showGoodsTotalAmount =
      previewStyle === 'both_price' || previewStyle === 'only_total_price';
    const showNumberWeight = !!template.textTemplate.saleNumberWeightFlag;
    const textStyle = getFieldStyle({
      fontSize: template.textTemplate.fontSize,
      boldFlag: template.textTemplate.boldFlag,
    });
    const totalValueMap = {
      totalGoodsAmount: '370元',
      tradeFee: '10元',
      totalAmount: '380元',
    };

    return (
      <div className='thermalPreviewPaper'>
        <div className='thermalPreviewNav'>
          <button
            type='button'
            className='thermalPreviewNavBtn'
            onClick={() => this.switchMemoPreviewStyle(-1)}
          >
            ◀
          </button>
          <span className='thermalPreviewNavLabel'>
            {styleDef.label} {previewStyleIndex + 1}/{MEMO_STYLE_DEFS.length}
          </span>
          <button
            type='button'
            className='thermalPreviewNavBtn'
            onClick={() => this.switchMemoPreviewStyle(1)}
          >
            ▶
          </button>
        </div>
        {headerFields.map((field) => {
          const meta = MEMO_HEAD_FIELDS.find((item) => item.key === field.fieldName);
          const sample =
            field.fieldName === 'buyerName' && template.showMasterBuyerName
              ? `${MEMO_SAMPLE.buyerName}(主买家)`
              : MEMO_SAMPLE[field.fieldName];
          if (field.fieldName === 'stallName') {
            return (
              <React.Fragment key={field.fieldName}>
                <div className='thermalPreviewLine' style={getFieldStyle(field)}>
                  {sample}
                </div>
                {template.showBarcode ? (
                  <div className='thermalPreviewBarcodeWrap'>
                    <div className='thermalPreviewBarcode' />
                    <div className='thermalPreviewBarcodeNo'>0187778397530506466</div>
                  </div>
                ) : null}
              </React.Fragment>
            );
          }
          const previewLabelMap = {
            memoNo: '码单',
            buyerName: '客户',
            buyerAddress: '地址',
          };
          const label = previewLabelMap[field.fieldName] || meta?.label;
          return (
            <div key={field.fieldName} className='thermalPreviewLine' style={getFieldStyle(field)}>
              {label}:{sample}
            </div>
          );
        })}
        <div className='thermalPreviewDivider' />
        {previewStyle === 'custom' ? (
          <table className='thermalPreviewTable'>
            <thead>
              <tr>
                {productColumnFields.map((field) => {
                  const meta = MEMO_PRODUCT_FIELDS.find((item) => item.key === field.fieldName);
                  return (
                    <th
                      key={field.fieldName}
                      style={{
                        ...getFieldStyle(template.tableTemplate.tableHead),
                        textAlign: field.align || 'left',
                        borderBottom: '1px dashed #000',
                      }}
                    >
                      {meta?.label}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {MEMO_SAMPLE.products.map((item, index) => (
                <React.Fragment key={item.name}>
                  <tr>
                    {productColumnFields.map((field) => (
                      <td
                        key={`${item.name}:${field.fieldName}`}
                        style={{ ...getFieldStyle(field), ...underlineStyle }}
                      >
                        {
                          {
                            productName: (
                              <>
                                {index + 1}.&nbsp;{item.name}
                                {template.showBatchCategory
                                  ? `(${[item.batch, item.category].filter(Boolean).join(' / ')})`
                                  : null}
                              </>
                            ),
                            packWeight: item.spec,
                            saleNumberWeight: item.qty,
                            unitPrice: item.price,
                            goodsAmount: item.amount,
                            packStatus: '',
                          }[field.fieldName]
                        }
                      </td>
                    ))}
                  </tr>
                  {productBasketField && item.basket ? (
                    <tr className='thermalPreviewRemarkRow'>
                      {productColumnFields.map((field) => (
                        <td
                          key={`${item.name}:basket:${field.fieldName}`}
                          style={{
                            ...getFieldStyle(productBasketField),
                            textAlign: field.align || 'left',
                            ...underlineStyle,
                          }}
                        >
                          {{
                            productName: item.basket.type,
                            saleNumberWeight: item.basket.qty,
                            unitPrice: item.basket.unitPrice,
                            goodsAmount: item.basket.amount,
                          }[field.fieldName] || ''}
                        </td>
                      ))}
                    </tr>
                  ) : null}
                  {productRemarkField && item.productRemark ? (
                    <tr className='thermalPreviewRemarkRow'>
                      <td
                        colSpan={Math.max(productColumnFields.length, 1)}
                        style={{ ...getFieldStyle(productRemarkField), ...underlineStyle }}
                      >
                        备注:{item.productRemark}
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <div>
            {MEMO_SAMPLE.products.map((item, index) => (
              <div key={item.name} className='thermalPreviewLine' style={{ ...textStyle }}>
                <div>
                  {index + 1}.&nbsp;{item.name}
                  {template.showBatchCategory
                    ? `(${[item.batch, item.category].filter(Boolean).join(' / ')})`
                    : null}
                </div>
                {template.globalUnderline ? <div className='thermalPreviewDivider' /> : null}

                {item.productRemark ? (
                  <>
                    <div style={{ marginTop: 2 }}>备注:{item.productRemark}</div>
                    {template.globalUnderline ? <div className='thermalPreviewDivider' /> : null}
                  </>
                ) : null}

                <div style={{ marginTop: 2 }}>
                  &nbsp;&nbsp;&nbsp;{item.qty2}
                  {showUnitPrice ? ` X ${item.price}` : null}
                </div>
                {template.globalUnderline ? <div className='thermalPreviewDivider' /> : null}

                {showGoodsAmount ? (
                  <>
                    <div style={{ marginTop: 2 }}>&nbsp;&nbsp;&nbsp;货款:{item.amount}</div>
                    {template.globalUnderline ? <div className='thermalPreviewDivider' /> : null}
                  </>
                ) : null}
              </div>
            ))}
          </div>
        )}
        {template.showReplenishArea ? (
          <>
            {Array.from({ length: template.replenishRows || 1 }).map((_, index) => (
              <div key={index} className='thermalPreviewLine'>
                &nbsp;
                {template.globalUnderline ? <div className='thermalPreviewDivider' /> : null}
              </div>
            ))}
          </>
        ) : null}
        {previewStyle === 'custom' ? (
          <>
            {totalFields.length && !template.globalUnderline ? (
              <div className='thermalPreviewDivider' />
            ) : null}
            {totalFields.map((field) => {
              const meta = MEMO_TOTAL_FIELDS.find((item) => item.key === field.fieldName);
              if (field.fieldName === 'totalNumberWeight') {
                return (
                  <React.Fragment key={field.fieldName}>
                    <div className='thermalPreviewLine' style={getFieldStyle(field)}>
                      总数量:9
                    </div>
                    <div className='thermalPreviewLine' style={getFieldStyle(field)}>
                      总重量:140
                    </div>
                  </React.Fragment>
                );
              }
              if (field.fieldName === 'chargeOrderFee') {
                return (
                  <React.Fragment key={field.fieldName}>
                    <div className='thermalPreviewLine' style={getFieldStyle(field)}>
                      {meta?.label}:10元
                    </div>
                    <div className='thermalPreviewLine' style={getFieldStyle(field)}>
                      备注:三楼送货费
                    </div>
                  </React.Fragment>
                );
              }
              const displayValue = totalValueMap[field.fieldName];
              return (
                <div
                  key={field.fieldName}
                  className='thermalPreviewLine'
                  style={getFieldStyle(field)}
                >
                  {meta?.label}:{displayValue}
                </div>
              );
            })}
          </>
        ) : (
          <>
            {(showNumberWeight || showGoodsTotalAmount) && !template.globalUnderline ? (
              <div className='thermalPreviewDivider' />
            ) : null}
            {showNumberWeight ? (
              <>
                <div className='thermalPreviewLine' style={textStyle}>
                  总数量:9
                </div>
                <div className='thermalPreviewLine' style={textStyle}>
                  总重量:140
                </div>
              </>
            ) : null}
            {showGoodsTotalAmount ? (
              <>
                {template.textTemplate.goodsAmountFlag ? (
                  <div className='thermalPreviewLine' style={textStyle}>
                    货&nbsp;&nbsp;&nbsp;款:370元
                  </div>
                ) : null}
                <div className='thermalPreviewLine' style={textStyle}>
                  三轮车费:10元
                </div>
                <div className='thermalPreviewLine' style={textStyle}>
                  力资费:10元
                </div>
                <div className='thermalPreviewLine' style={textStyle}>
                  总&nbsp;&nbsp;&nbsp;计:380元
                </div>
              </>
            ) : null}
          </>
        )}
        <div className='thermalPreviewDivider' />
        {(() => {
          const createNameField = footerFields.find((field) => field.fieldName === 'createName');
          const createTimeField = footerFields.find((field) => field.fieldName === 'createTime');
          const renderFooterLabel = (label) => (
            <span className='thermalPreviewFooterLabel'>{label}</span>
          );
          const renderColon = () => <span className='thermalPreviewColon'>:</span>;
          const renderLabelLine = (field) => {
            if (!field) return null;
            const meta = MEMO_END_FIELDS.find((item) => item.key === field.fieldName);
            const sample = MEMO_FOOTER_SAMPLE[field.fieldName];
            return (
              <div
                key={field.fieldName}
                className='thermalPreviewLine'
                style={getFieldStyle(field)}
              >
                {renderFooterLabel(meta?.label)}
                {renderColon()}
                {sample}
              </div>
            );
          };

          return (
            <React.Fragment>
              {createNameField ? (
                <div className='thermalPreviewLine' style={getFieldStyle(createNameField)}>
                  {renderFooterLabel('开票员')}
                  {renderColon()}
                  {MEMO_FOOTER_SAMPLE.createName}
                  {createTimeField ? (
                    <span style={{ ...getFieldStyle(createTimeField), marginLeft: 8 }}>
                      {MEMO_FOOTER_SAMPLE.createTime}
                    </span>
                  ) : null}
                </div>
              ) : (
                renderLabelLine(createTimeField)
              )}
              {footerFields
                .filter((field) => !['createName', 'createTime'].includes(field.fieldName))
                .map(renderLabelLine)}
            </React.Fragment>
          );
        })()}
        {qrcodeUrl ? (
          <div className='thermalPreviewQrCodeWrap'>
            <QRCode value={qrcodeUrl} size={80} level='M' />
            {qrcodeHint ? <div>{qrcodeHint}</div> : null}
          </div>
        ) : null}
        {advertisingField ? (
          <>
            <div className='thermalPreviewDivider' />
            <div
              className='thermalPreviewAd'
              style={{ ...getFieldStyle(advertisingField), textAlign: 'center' }}
            >
              {MEMO_FOOTER_SAMPLE.advertising}
            </div>
          </>
        ) : null}
      </div>
    );
  };

  render() {
    const { loading, saving, template } = this.state;
    const textTemplate = template.textTemplate;
    return (
      <PageHeaderLayout>
        <div className='StallManagementDetail'>
          <div className='thermalPrinterEditPage'>
            <div className='thermalEditTitle'>
              编辑码单模板
              <span className='thermalEditHint'>
                新模板的字体大小对旧的思普瑞特打印机不生效，对旧的皇胜打印机生效
              </span>
            </div>
            <Spin spinning={loading}>
              <div className='thermalEditLayout'>
                <div className='thermalEditMain'>
                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>表头字段</div>
                    {this.renderFieldGrid(MEMO_HEAD_FIELDS, template.headList, this.updateTopField)}
                  </div>

                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>货品样式</div>
                    {this.renderStyleTabs()}
                    {this.state.activeEditStyle === 'custom' ? (
                      <Space direction='vertical' style={{ width: '100%' }} size={12}>
                        <ThermalPrinterTableHeadEditor
                          value={template.tableTemplate.tableHead}
                          onChange={(next) =>
                            this.setTemplate((draft) => {
                              draft.tableTemplate.tableHead = next;
                            })
                          }
                        />
                        <div>货品</div>
                        {this.renderFieldGrid(
                          MEMO_PRODUCT_FIELDS,
                          template.tableTemplate.productList,
                          this.updateProductField,
                        )}
                        <div>合计</div>
                        {this.renderFieldGrid(
                          MEMO_TOTAL_FIELDS,
                          template.tableTemplate.totalList,
                          this.updateTotalField,
                        )}
                      </Space>
                    ) : (
                      <Space direction='vertical' style={{ width: '100%' }} size={12}>
                        <div className='thermalFieldGrid'>
                          <ThermalPrinterTextStyleChip
                            label='码单字号'
                            value={textTemplate}
                            onChange={(next) =>
                              this.setTemplate((draft) => {
                                draft.textTemplate = {
                                  ...draft.textTemplate,
                                  ...next,
                                };
                              })
                            }
                          />
                        </div>
                        <div className='thermalFieldGrid'>
                          <ThermalPrinterToggleChip
                            label='总数量/总重量'
                            checked={!!textTemplate.saleNumberWeightFlag}
                            onChange={(checked) =>
                              this.setTemplate((draft) => {
                                draft.textTemplate.saleNumberWeightFlag = checked;
                              })
                            }
                          />
                          <ThermalPrinterToggleChip
                            label='货款'
                            checked={!!textTemplate.goodsAmountFlag}
                            tooltip='勾选货款后，货款只在“仅显示总价、显示单价和总价”两种样式中展示'
                            onChange={(checked) =>
                              this.setTemplate((draft) => {
                                draft.textTemplate.goodsAmountFlag = checked;
                              })
                            }
                          />
                        </div>
                      </Space>
                    )}
                  </div>

                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>表尾字段</div>
                    {this.renderFieldGrid(
                      MEMO_END_FIELDS,
                      template.endList,
                      this.updateFooterField,
                    )}
                  </div>

                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>其他配置</div>
                    <div className='thermalSwitchGrid'>
                      <div className='thermalSwitchRow'>
                        <span>加下划线</span>
                        <Switch
                          checked={template.globalUnderline}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.globalUnderline = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>显示批次/货品分类</span>
                        <Switch
                          checked={template.showBatchCategory}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showBatchCategory = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchStack'>
                        <div className='thermalSwitchRow'>
                          <span className='thermalSwitchRowLabel'>
                            加手写区域
                            <span className='thermalSwitchRowLabelHint'>
                              在货品末尾留空行供手写补货
                            </span>
                            {template.showReplenishArea ? (
                              <div className='thermalInputRow thermalSwitchSubRow'>
                                <span>补货空行数量</span>
                                <ThermalPrinterNumberInput
                                  value={template.replenishRows}
                                  onChange={(value) =>
                                    this.setTemplate((draft) => {
                                      draft.replenishRows = value;
                                    })
                                  }
                                />
                              </div>
                            ) : null}
                          </span>
                          <Switch
                            checked={template.showReplenishArea}
                            onChange={(checked) =>
                              this.setTemplate((draft) => {
                                draft.showReplenishArea = checked;
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>扫码取单</span>
                        <Switch
                          checked={template.showBarcode}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showBarcode = checked;
                            })
                          }
                        />
                      </div>
                    </div>
                    <Space direction='vertical' style={{ width: '100%', marginTop: 12 }}>
                      <div className='thermalSwitchRow'>
                        <span>显示关联主买家</span>
                        <Switch
                          aria-label='显示关联主买家'
                          checked={template.showMasterBuyerName}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showMasterBuyerName = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>自动同步商行二维码</span>
                        <Switch
                          aria-label='自动同步商行二维码'
                          checked={template.autoSyncStallQrcodeUrl}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.autoSyncStallQrcodeUrl = checked;
                            })
                          }
                        />
                      </div>
                      {!template.autoSyncStallQrcodeUrl ? (
                        <Input
                          maxLength={500}
                          showCount
                          placeholder='请输入二维码链接'
                          value={template.qrcodeUrl}
                          onChange={(e) =>
                            this.setTemplate((draft) => {
                              draft.qrcodeUrl = e.target.value;
                            })
                          }
                        />
                      ) : null}
                      {!template.autoSyncStallQrcodeUrl ? (
                        <Input
                          maxLength={20}
                          showCount
                          placeholder='请输入二维码提示语'
                          value={template.qrcodeHint}
                          onChange={(e) =>
                            this.setTemplate((draft) => {
                              draft.qrcodeHint = e.target.value;
                            })
                          }
                        />
                      ) : null}
                    </Space>
                  </div>

                  <div className='thermalEditFooter'>
                    <Button onClick={this.goBackToStallDetail}>取消</Button>
                    <Button type='primary' loading={saving} onClick={this.handleSave}>
                      保存
                    </Button>
                  </div>
                </div>
                <div className='thermalPreviewPanel'>{this.renderPreview()}</div>
              </div>
            </Spin>
          </div>
        </div>
      </PageHeaderLayout>
    );
  }
}

export default StallThermalPrinterMemoEdit;
